import { ViewModel, View } from "binder"
import { StopGroupEditorView } from "./stopGroupEditor-view"
import { IStopGroup } from "../IStopGroup";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class StopGroupEditorViewModel extends ViewModel implements IStopGroup, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
    }
    GetDefaultView(): View<ViewModel> {
        return new StopGroupEditorView();
    }
    public getTypeId(): string {
        return "VM-8E416B74-60C9-4F03-AE54-908D7B61041E"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set isDisable(v: boolean) { this._isDisable = v; } public get isDisable(): boolean { return this._isDisable; } private _isDisable: boolean;

    closePopup(result?: any) {

    }

    async cloneTo(stopGroup: IStopGroup) {
        stopGroup.id = this.id;
        stopGroup.name = this.name;
        stopGroup.code = this.code;
        stopGroup.isDisable = this.isDisable;
    }

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت گروه توقف');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت گروه توقف تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('گروه توقف با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            }
            catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت گروه توقف', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push('نام گروه مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(stopGroup: IStopGroup): Promise<any>;
}

export class StopGroupInserter implements IServerUpdater {
    async execute(stopGroup: IStopGroup): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/StopGroupServices/CreateStopGroup', {
                Name: stopGroup.name
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class StopGroupUpdater implements IServerUpdater {
    async execute(stopGroup: IStopGroup): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/StopGroupServices/UpdateStopGroup', {
                StopGroupId: stopGroup.id,
                Name: stopGroup.name
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
